import axios from 'axios';

async function errorHandler(error) {
    if (error.response && error.response.data) {
        throw error.response.data;
    } else {
        throw error;
    }
}

export default {
    async list(obj) {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'remark', 'createby', 'nmcategory', 'jasa', 'requestno', 'mrequestno', 'tgl1', 'tgl2', 'outstand', 'DimCol', 'DimColInfo', 'DimVal', 'approved', 'pr', 'statuswf', 'barter'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            let url = `/pr${str}`;
            if (obj.viewOption == 'Header') {
                url = `/pr/list${str}`;
            }

            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            return list;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async save(obj) {
        try {
            const { data } = await axios.post("pr", obj);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async remove(obj) {
        try {
            const resp = await axios.delete(`/pr/${obj.requestkey}`);
            return resp;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async closed(obj) {
        try {
            const resp = await axios.put(`/pr/closed/${obj.reqdtlkey}`, obj);
            return resp;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async detail(obj) {
        try {
            const { data } = await axios.get(`/pr/detail/${obj.requestkey}`);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async actionhistory(obj) {
        try {
            const { data } = await axios.get(`/pr/actionhistory/${obj.requestkey}`);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async exportxls(obj = {}) {
        let url_blob;
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'remark', 'createby', 'nmcategory', 'jasa', 'requestno', 'mrequestno', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal', 'approved', 'pr', 'statuswf', 'barter'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            let url = `/pr/exportxls${str}`;
            if (obj.viewOption == 'Header') {
                url = `/pr/exporthdrxls${str}`;
            }
            const response = await axios({
                url,
                method: 'GET',
                responseType: 'blob',
            });
            url_blob = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url_blob;
            if (obj.viewOption == 'Header') {
                link.setAttribute('download', 'purchase_request_header_list.xlsx');
            } else {
                link.setAttribute('download', 'purchase_request_list.xlsx');
            }
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => window.URL.revokeObjectURL(url_blob), 100);
            return true;
        } catch (error) {
            if (url_blob) window.URL.revokeObjectURL(url_blob);
            await errorHandler(error);
        }
    },
    async approval(formData) {
        try {
            const { data } = await axios.post("pr/send2wf", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async approvalUndo(obj) {
        try {
            const resp = await axios.put(`/pr/send2wfCancel/${obj.requestkey}`);
            return resp;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async print(obj) {
        try {
            if (obj.requestkey) {
                obj.typePR = obj.typePR || 'close';
                const url = `/pr/print?requestkey=${obj.requestkey}&typePR=${obj.typePR}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                return link;
            }
        } catch (error) {
            await errorHandler(error);
        }
    }
};